'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

var _components = require('../../components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PasswordInput = require('./PasswordInput.scss');

var _PasswordInput2 = _interopRequireDefault(_PasswordInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordInput = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(PasswordInput, _Component);

    function PasswordInput(props, context) {
        (0, _classCallCheck3.default)(this, PasswordInput);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordInput.__proto__ || (0, _getPrototypeOf2.default)(PasswordInput)).call(this, props, context));

        _this.onValueChange = function (event) {
            _this.props.onValueChange(event.target.value);
        };

        _this.getPasswordLabel = function (iconName, showLabel) {
            return (0, _jsx3.default)('div', {
                className: _PasswordInput2.default['password-label']
            }, void 0, (0, _jsx3.default)('span', {
                className: _PasswordInput2.default.label
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'password'
            })), (0, _jsx3.default)('span', {
                className: _PasswordInput2.default.eye,
                onClick: _this.showHide
            }, void 0, (0, _jsx3.default)(_caterwaulComponents.Icon, {
                className: _PasswordInput2.default.icon,
                name: iconName
            }), (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: showLabel
            })));
        };

        _this.showHide = function (event) {
            event.preventDefault();
            event.stopPropagation();
            _this.setState({
                passwordInputType: _this.state.passwordInputType === 'password' ? 'text' : 'password'
            });
        };

        _this.state = {
            passwordInputType: props.isMobile ? 'text' : 'password'
        };
        _this.showHide = _this.showHide.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PasswordInput, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                handleEnterKeyPress = _props.handleEnterKeyPress,
                errorMessage = _props.errorMessage,
                valid = _props.valid;
            var passwordInputType = this.state.passwordInputType;


            var iconName = this.state.passwordInputType === 'password' ? 'eye' : 'eye-slash';
            var showLabel = this.state.passwordInputType === 'password' ? 'show' : 'hide';
            var passwordLabel = this.getPasswordLabel(iconName, showLabel);

            return (0, _jsx3.default)(_components.Input, {
                autoCapitalize: false,
                autoComplete: false,
                autoCorrect: false,
                dontRecordForFullstory: true,
                errorMessage: errorMessage || (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'your_password_length'
                }),
                id: 'pw',
                label: passwordLabel,
                onChange: this.onValueChange,
                onKeyPress: handleEnterKeyPress,
                type: passwordInputType,
                valid: valid,
                wide: true
            });
        }
    }]);
    return PasswordInput;
}(_react.Component), _class.defaultProps = {
    errorMessage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'your_password_length'
    })
}, _temp);
exports.default = PasswordInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PasswordInput/PasswordInput.js
// module id = iUDN
// module chunks = 46